import React, { memo } from 'react';
import classNames from 'classnames';

import { SpinnerProps } from '@/components/spinner/types';

const Spinner = ({ classname }: SpinnerProps) => (
	<div className={classNames('spinner', classname)} />
);

export default memo(Spinner);
